import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Link from '../../../Link';
import { HeaderContext } from '../../headerContext';

const StyledMenuTitle = styled.h4`
  ${(props) => props.theme.typography.bodyBold};
  border-top: 1px solid ${(props) => props.theme.colors.grayscale.gray3};
  border-bottom: 1px solid ${(props) => props.theme.colors.grayscale.gray3};
  color: ${(props) => props.theme.colors.grayscale.black};
  margin: 0;
  padding: 0.625rem 1rem;
  text-transform: uppercase;
`;

const StyledMenu = styled.ul`
  list-style: none;
  padding: 0;

  li:first-child {
    > a {
      padding-top: 0.25rem;
    }
  }
`;

const StyledListEntry = styled.li`
  padding: 0;

  a {
    ${(props) => props.theme.typography.body};
    color: ${(props) => props.theme.colors.grayscale.black};
    display: inline-block;
    padding: 0.75rem 1rem;
    width: 100%;
  }
`;

function MobileStudioSelector({ id, studiosPath, onClick, LinkWrapper }) {
  const headerContext = useContext(HeaderContext);
  const { studios, currentRegion } = headerContext;

  const handleStudioClick = (studio) => {
    if (typeof onClick === 'function') {
      onClick(studio);
      return;
    }

    console.error(
      'onClick passed to MobileStudioSelector is not a valid function'
    );
  };

  return (
    <>
      <StyledMenuTitle>{`${currentRegion.name} studios:`}</StyledMenuTitle>
      <StyledMenu id={id}>
        {studios.map((studio) => (
          <StyledListEntry key={studio.id}>
            <Link
              id={`header-studios-list-${studio.title.replace(/ /, '-')}`}
              href={`${studiosPath}/${studio.id}`}
              LinkWrapper={LinkWrapper}
              onClick={() => handleStudioClick(studio)}
            >
              {studio.title}
            </Link>
          </StyledListEntry>
        ))}
      </StyledMenu>
    </>
  );
}

MobileStudioSelector.propTypes = {
  /**
   * Path to prepend for a studio URL
   */
  studiosPath: PropTypes.string,
  /**
   * onClick handler for selecting a studio
   */
  onClick: PropTypes.func,
  /**
   * link wrapper for the Link component
   */
  LinkWrapper: PropTypes.func,
  /**
   * id the MobileStudioSelector component
   */
  id: PropTypes.string,
};

MobileStudioSelector.defaultProps = {
  studiosPath: '/find-a-class/studio',
  LinkWrapper: null,
  id: 'mobile-studio-selector',
  onClick: () => {},
};

/* @component */
export default MobileStudioSelector;
